import React, { useMemo } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Order } from "../../../../../../../models/order";
import { ItemJob } from "../../../../../../../models/sales";
import { calculateTotalVolume } from "../../../../../../../util/calculateTotalVolume";
import { ItemJobSubStatus } from "../../../../../../../util/enums";
import { getMeasurement } from "../../../../../../../util/getMeasurement";
import CardContainer from "../../Maintenance/Tabs/components/Details/CardContainer";

interface Props {
  transshipmentJobs?: Order[];
}

export const OrdersTab = ({ transshipmentJobs }: Props) => {
  const { t: translate } = useTranslation();

  const measurement = getMeasurement();

  const allItemsJobs = useMemo(() => {
    const itemsJobs: ItemJob[] = [];

    if (transshipmentJobs) {
      transshipmentJobs?.forEach((job) => {
        if (job?.itemsJob && job?.itemsJob?.length) {
          job?.itemsJob?.forEach((itemJob) => {
            itemsJobs.push(itemJob);
          });
        }
      });
    }

    return itemsJobs;
  }, [transshipmentJobs]);

  return (
    
    <Grid item xs={12}>
      <CardContainer
        isViewMode={true}
        title={`${transshipmentJobs?.length || 0} ${translate("added")}`}
        info={translate("planned")}
        volume={calculateTotalVolume(ItemJobSubStatus.ACTUAL, measurement, allItemsJobs)}
        orders={transshipmentJobs}
      />
    </Grid>
  );
};
